import { render } from "./HelpCenter-page.vue?vue&type=template&id=4a05c7b0&scoped=true"
import script from "./HelpCenter-page.vue?vue&type=script&lang=js"
export * from "./HelpCenter-page.vue?vue&type=script&lang=js"

import "./HelpCenter-page.vue?vue&type=style&index=0&id=4a05c7b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05c7b0"]])

export default __exports__